<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 21"
    fill="none"
    :width="width"
    :height="height"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0001 19.5221C5.02522 19.5221 0.977905 15.4746 0.977905 10.4999C0.977905 5.52509 5.02522
        1.47788 10.0001 1.47788C14.975 1.47788 19.0221 5.52509 19.0221 10.4999C19.0221 15.4746
        14.975 19.5221 10.0001 19.5221ZM10.0001 0.5C4.48618 0.5 0 4.98603 0 10.4999C0 16.0139
        4.48618 20.5 10.0001 20.5C15.5141 20.5 20 16.0139 20 10.4999C20 4.98603 15.5141 0.5 10.0001
        0.5Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 8.77588C9.80967 8.77588 9.65518 8.99577 9.65518 9.2667V15.1816C9.65518 15.4525 9.80967
        15.6724 10 15.6724C10.1904 15.6724 10.3448 15.4525 10.3448 15.1816V9.2667C10.3448 8.99577
        10.1905 8.77588 10 8.77588Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0023 6.70689C9.80747 6.70689 9.65517 6.55579 9.65517 6.36281C9.65517 6.16911 9.80786
        6.01723 10.0023 6.01723C10.191 6.01723 10.3448 6.1722 10.3448 6.36281C10.3448 6.55231 10.191
        6.70689 10.0023 6.70689ZM10.002 5.32758C9.4302 5.32758 8.96552 5.79193 8.96552
        6.3627C8.96552 6.93286 9.4302 7.39654 10.002 7.39654C10.5711 7.39654 11.0345 6.93286 11.0345
        6.3627C11.0345 5.79193 10.5711 5.32758 10.002 5.32758Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'CgIconInfoCircle',
  props: {
    width: {
      type: [Number, String],
      required: false,
      default: 20,
    },
    height: {
      type: [Number, String],
      required: false,
      default: 20,
    },
    color: {
      type: String,
      required: false,
      default: '#4A4A4A',
    },
  },
});
</script>
